import { render, staticRenderFns } from "./UiTagGroup.vue?vue&type=template&id=793f7013&scoped=true"
import script from "./UiTagGroup.vue?vue&type=script&lang=js"
export * from "./UiTagGroup.vue?vue&type=script&lang=js"
import style0 from "./UiTagGroup.vue?vue&type=style&index=0&id=793f7013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f7013",
  null
  
)

export default component.exports